import {AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {HeaderService} from '../../core/services/header.service';
import {AuthService} from '../../core/security/auth.service';
import {merge} from 'rxjs';
import {RolesEnum} from '../../core/security/roles.enum';
import {MatPaginator} from '@angular/material/paginator';
import { MatSort, MatSortHeader } from '@angular/material/sort';
import {tap} from 'rxjs/operators';
import {MatDialog} from '@angular/material/dialog';
import {EventsFlowService as EventsFlowApiService} from '../../api/services/events-flow.service';
import {EventsFlowDatasource} from './events-flow.datasource';
import {GetEventsFlowListRequest} from '../../api/models/get-events-flow-list-request';
import { FlexModule } from '@angular/flex-layout';
import { NgIf, AsyncPipe } from '@angular/common';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from '@angular/material/table';
import { RouterLink } from '@angular/router';
import { YesNoPipe } from '../../core/pipes/yesno.pipe';

@Component({
    selector: 'app-events-flow-grid',
    templateUrl: './events-flow-grid.component.html',
    styleUrls: ['./events-flow-grid.component.scss'],
    standalone: true,
    imports: [
        FlexModule,
        NgIf,
        MatProgressSpinner,
        MatTable,
        MatSort,
        MatColumnDef,
        MatHeaderCellDef,
        MatHeaderCell,
        MatSortHeader,
        MatCellDef,
        MatCell,
        RouterLink,
        MatHeaderRowDef,
        MatHeaderRow,
        MatRowDef,
        MatRow,
        MatPaginator,
        AsyncPipe,
        YesNoPipe,
    ],
})
export class EventsFlowGridComponent implements OnDestroy, OnInit, AfterViewInit {
  displayedColumns: string[] = [
    'name',
    'description',
    'eventType',
    'enabled',
  ];
  @Input() filterChangeEvent: EventEmitter<any>;

  initialLoad = true;

  hasSupportAccess = false;
  additionalFilter: any = {};
  recIdFilter: string;
  searchText: string;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  dataSource: EventsFlowDatasource;
  detailsUrl: string;
  hasEditAccess: boolean;


  constructor(public dialog: MatDialog,
              public headerService: HeaderService, public authService: AuthService,
              private eventsFlowApiService: EventsFlowApiService,
  ) {
  }

  ngOnInit() {
    this.hasSupportAccess = this.authService.hasAccess([RolesEnum.Support]);
    this.hasEditAccess = this.authService.hasAccess([RolesEnum.Support]);
    this.dataSource = new EventsFlowDatasource(this.eventsFlowApiService);
    this.detailsUrl = '../edit';
  }

  ngAfterViewInit() {
    this.filterChangeEvent?.subscribe((filter) => {
      this.additionalFilter = filter;
      this.paginator.pageIndex = 0;
    });

    this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);

    merge(this.sort.sortChange, this.paginator.page, this.filterChangeEvent)
      .pipe(
        tap(() => this.loadData())
      )
      .subscribe();

    this.initialLoad = false;
  }

  loadData() {
    console.log('filter changed');
    this.dataSource.queryData(this.getDataFilter());
  }

  getDataFilter(): GetEventsFlowListRequest {
    const baseRequest = {
      skip: this.paginator.pageIndex * this.paginator.pageSize,
      limit: this.paginator.pageSize,
      sort: [{field: this.sort.active, direction: this.sort.direction ? this.sort.direction.toUpperCase() : undefined}],
    };

    return Object.assign(baseRequest, this.additionalFilter || {});
  }

  ngOnDestroy() {

  }
}
